import { useEffect, useState } from "react";
import { API } from "../lib/api";
import axios from "axios";

const SECTION_LABELS = {
  account_overview:          "01 · Account Snapshot",
  what_is_working:           "02 · What's Working",
  worked_before_missing_now: "03 · What Worked Before",
  active_but_not_working:    "04 · Active But Draining",
  structural_gaps:           "05 · Structural Issues",
  new_campaign_opportunities:"06 · New Campaign Opportunities",
  next_steps:                "07 · Next Steps",
};

function Block({ title, children }) {
  const [open, setOpen] = useState(true);
  return (
    <div className="rounded-xl border border-slate-200 overflow-hidden">
      <button
        onClick={() => setOpen(o => !o)}
        className="w-full flex items-center justify-between px-5 py-3.5 bg-slate-50 text-left hover:bg-slate-100 transition-colors"
      >
        <span className="text-sm font-semibold text-slate-700">{title}</span>
        <span className="text-slate-400 text-xs">{open ? "collapse" : "expand"}</span>
      </button>
      {open && (
        <pre className="px-5 py-4 text-xs leading-relaxed text-slate-700 whitespace-pre-wrap font-mono bg-white overflow-x-auto">
          {children}
        </pre>
      )}
    </div>
  );
}

export default function PromptsPage() {
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    axios.get(`${API}/prompts`)
      .then(r => setData(r.data))
      .catch(() => setError("Could not load prompts — is the backend running?"));
  }, []);

  if (error) return (
    <div className="min-h-screen flex items-center justify-center text-sm text-rose-600">{error}</div>
  );
  if (!data) return (
    <div className="min-h-screen flex items-center justify-center text-sm text-slate-400">Loading…</div>
  );

  return (
    <div className="min-h-screen bg-slate-50">
      <div className="max-w-4xl mx-auto px-6 py-10">
        <div className="mb-8">
          <h1 className="text-2xl font-semibold text-slate-900">Prompts</h1>
          <p className="mt-1 text-sm text-slate-500">
            Live view — reflects the current state of <code className="text-xs bg-slate-100 px-1.5 py-0.5 rounded">claude_service.py</code> immediately on save.
          </p>
        </div>

        <div className="space-y-4">
          <Block title="System Prompt (Briefing)">
            {data.system}
          </Block>

          <div className="rounded-xl border border-slate-200 overflow-hidden">
            <div className="px-5 py-3.5 bg-slate-50 border-b border-slate-200">
              <span className="text-sm font-semibold text-slate-700">Section Instructions</span>
            </div>
            <div className="divide-y divide-slate-100">
              {data.sections.map(s => (
                <details key={s.key} className="group">
                  <summary className="flex items-center justify-between px-5 py-3 cursor-pointer hover:bg-slate-50 list-none">
                    <span className="text-xs font-semibold text-slate-600">
                      {SECTION_LABELS[s.key] || s.title}
                    </span>
                    <span className="text-[10px] text-slate-400 group-open:hidden">expand</span>
                    <span className="text-[10px] text-slate-400 hidden group-open:inline">collapse</span>
                  </summary>
                  <pre className="px-5 py-4 text-xs leading-relaxed text-slate-700 whitespace-pre-wrap font-mono bg-white border-t border-slate-100 overflow-x-auto">
                    {s.instruction}
                  </pre>
                </details>
              ))}
            </div>
          </div>

          <Block title="Rating System Prompt">
            {data.rating_system}
          </Block>

          <Block title="Chat System Prompt">
            {data.chat_system}
          </Block>
        </div>
      </div>
    </div>
  );
}
